import React from 'react';
import SharkIcon from 'assets/levels/shark.webp';
import DolphinIcon from 'assets/levels/dolphin.webp';
import OctopusIcon from 'assets/levels/octopus.webp';
import FishIcon from 'assets/levels/fish.webp';
import CrabsIcon from 'assets/levels/crab.webp';
import WhaleIcon from 'assets/levels/whale.webp';
import ShirmIcon from 'assets/levels/shirm.webp';
import styles from './levelHeader.module.scss';

const levelIconMap: Record<string, { src: string; width: number; alt: string }> = {
  crab: { src: CrabsIcon, width: 50, alt: 'Crab' },
  octopus: { src: OctopusIcon, width: 49, alt: 'Octopus' },
  fish: { src: FishIcon, width: 50, alt: 'Fish' },
  dolphin: { src: DolphinIcon, width: 50, alt: 'Dolphin' },
  shark: { src: SharkIcon, width: 50, alt: 'Shark' },
  whale: { src: WhaleIcon, width: 62, alt: 'Whale' },
};

export const getLevelIcon = (levelName: string) => {
  const icon = levelIconMap[levelName?.toLowerCase()] || {
    src: ShirmIcon,
    width: 50,
    alt: 'Shirm',
  };
  return <img src={icon.src} alt={icon.alt} width={icon.width} />;
};

export interface LevelData {
  name: string;
  wager?: string;
  gradient: string;
  description?: string;
}

export interface LevelHeaderProps {
  levels: string[];
  isMobile?: boolean;
  activeLevel?: number;
  onSelectLevel?: (level: number) => void;
}

const LevelHeader: React.FC<LevelHeaderProps> = ({
  levels,
  isMobile,
  activeLevel,
  onSelectLevel,
}) => {
  return (
    <div className={isMobile ? styles.mobileHeaderRow : styles.desktopHeaderRow}>
      {levels.map((level, idx) => (
        <div
          key={idx}
          className={`${styles.headerCell} ${isMobile ? styles.mobileCell : ''} ${activeLevel === idx ? styles.active : ''}`}
          onClick={(e) => {
            if (onSelectLevel) {
              onSelectLevel(idx);
              e.currentTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
              });
            }
          }}
          style={{ cursor: onSelectLevel ? 'pointer' : 'default' }}
        >
          <div className={styles.levelLogo}>{getLevelIcon(level)}</div>
          <span className={styles.levelName}>{level}</span>
        </div>
      ))}
    </div>
  );
};

export default LevelHeader;
